<template>

    <div class="c-dropzone">
        <div
            class="c-dropzone__container"
            @dragover="dragover"
            @dragleave="dragleave"
            @drop="drop"
            :style="isDragging && 'border-color: green;'"
        >
        <input
            type="file"
            multiple
            name="file"
            id="fileInput"
            class="c-dropzone__hidden-input"
            @change="onChange"
            ref="file"
            accept=".pdf,.jpg,.jpeg,.png,.docx,.xls"
        />
        
      <p v-if="errorText" class="is-error">
            {{ errorText }}
      </p>
      
      <label for="fileInput" class="c-dropzone__file-label">
        <div v-if="isDragging" class="c-dropzone__file-label-releasetext">{{ $t('internalfiles.releasefileshere') }}</div>
        <div v-else class="c-dropzone__file-label-droptext">
            {{ $t('internalfiles.dropfileshere') }}
        </div>
      </label>  
     
    </div>
    <div>
        <button class="button" @click="uploadFiles"> {{ $t('internalfiles.clicktoupload') }}</button>
    </div> 

    <div class="c-dropzone__preview-container" v-if="files.length">
        <div v-for="file in files" :key="file.name" class="c-dropzone__preview-card" :class="file.classname">
            <span v-if="file.error">{{ file.error }}</span>
            <span class="c-dropzone__filename">
              {{ file.name }} <br> <strong>{{ Math.round(file.size / 1000) + " KB" }}</strong>
            </span>
            <button
              class="close-button"
              type="button"
              @click="remove(files.indexOf(file))"
              title="Remove file"
            >
              <span aria-hidden="true">x</span>
            </button>
        </div>
      </div>
    
  </div>
</template>
<script>
export default {
    name: "DropZoneUpload",
    props: {
        projectId: {
            type: [String, Number],
            required: true
        },
        projectNumber: {
            type: [String, Number],
            required: true
        },
    },
    data() {
        return {
            isDragging: false,
            files: [],
            errorText: ''
        };
    },
    methods: {
        onChange() {
            const self = this;
            
            // See if we have a duplicate in the file list
            let incomingFiles = Array.from(this.$refs.file.files);
            const fileExist = self.files.some((r) =>
                incomingFiles.some(
                (file) => file.name === r.name && file.size === r.size
                )
            );
            if (fileExist) {
               this.errorText = this.$t('exceptions.uploads.file_already_exists');
            } else {
                self.files.push(...incomingFiles);
            }
            
            // Check for accepted extensions
            const acceptedFileExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'docx', 'xls'];
            self.files.forEach((file) => {
                const fileExtension = file.name.split('.').pop();
                if(!acceptedFileExtensions.includes(fileExtension)) {
                    this.errorText = this.$t('exceptions.uploads.extension_not_allowed');
                    const index = self.files.indexOf(file);
                    if (index !== -1) {
                        self.files.splice(index,1);
                    }
                }
            })
            
        },
        dragover(e) {
            e.preventDefault();
            this.errorText = '';
            this.isDragging = true;
        },
        dragleave(e) {
            e.preventDefault();
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.onChange();
            this.isDragging = false;
        },
        remove(i) {
            this.errorText = '';
            this.files.splice(i, 1);
        },
        uploadFiles(e) {
            e.preventDefault();
            e.stopPropagation();
            let promises = [];
            this.files.forEach((file, index) => {
                const fileObject = {
                    comment: '',
                    file: file,
                    id: 0,
                    project_id: this.projectId,
                    project_number: this.projectNumber,
                };
                
                // add uploading message
                file.classname = 'is-uploading';
                this.files.splice(index, 1, file);
                
                promises.push(
                    new Promise((resolve, reject) => {
                        let promise = this.$api
                        .clearParams()
                        .post("internalfiles/create", this.$api.getFormData(fileObject), {
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        });
                        promise
                        .then(
                            (response => {
                                file.classname = 'is-success';
                                this.files.splice(index, 1, file);
                                resolve();
                            }).bind(this)
                        )
                        .catch(
                            (error => {
                                file.classname = 'is-error';
                                file.error = error.message;
                                this.files.splice(index, 1, file);
                                reject(error);
                            }).bind(this)
                        );
                    })
                );
            })
            
            // Watch all of our triggered promises in order to react globally 
            Promise.all(promises).then(() => {
                this.files = [];
            }).catch((error) => {
                console.log('at least one error', error);
            }).finally(() => {
                this.$emit("onAction", "upload");
            });
        },
    },
};
</script>
